const NAME = "LANGUAGES";

export default NAME;
